import angular from 'angular';
import uiRouter from 'angular-ui-router';
import categoriesComponent from './categories.component';
import categoriesListComponent from './categories-list.component';
import categoriesService from './categories.service';

let categoriesModule = angular.module('categories', [
  uiRouter
])
.service('CategoriesService', categoriesService)
.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/categories');

  $stateProvider
    .state('categories', {
      component: 'categories'
    })
    .state('categories.list', {
      url: '/categories',
      component: 'categoriesList'
    })
})
.component('categories', categoriesComponent)
.component('categoriesList', categoriesListComponent)
.name;

export default categoriesModule;


// WEBPACK FOOTER //
// ./client/app/components/categories-faq/categories.js